import { combineReducers } from 'redux';

import chats from './chats';

export default combineReducers({
  chats
});
